import { render } from "./TemplateFrameOptionDisplays.vue?vue&type=template&id=07471d26&scoped=true"
import script from "./TemplateFrameOptionDisplays.vue?vue&type=script&lang=js"
export * from "./TemplateFrameOptionDisplays.vue?vue&type=script&lang=js"

import "./templateFrameOptionDisplays.scss?vue&type=style&index=0&id=07471d26&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07471d26"]])

export default __exports__